import React from "react";
import parse from "html-react-parser";
import { StyledResolutionNotes } from "./styled";

function ResolutionNotes({ margin, notes = [], rounded = true }) {
  const visibleNotes = notes.filter((note) => note?.content);

  if (visibleNotes.length === 0) {
    return null;
  }

  return (
    <StyledResolutionNotes
      className="v2-resolution-notes"
      margin={margin}
      rounded={rounded}
    >
      {visibleNotes.map((note) => (
        <div className="v2-resolution-note-card" key={note.title}>
          <p className="v2-resolution-note-title">{note.title}</p>
          <div className="v2-resolution-note-content">
            {typeof note.content === "string" ? parse(note.content) : note.content}
          </div>
        </div>
      ))}
    </StyledResolutionNotes>
  );
}

export default ResolutionNotes;
